import React from "react";
import Image from "next/image";

export const BRAND_NAME = "Хөвсгөл карго";
export const BRAND_TAGLINE = "Мандал каргоны салбар";
export const BRAND_ROUTE = "Эрээн – Хөвсгөл";

// Брэндийн тэмдэг + нэр (Header, Footer). Тэмдэг нь түр лого (public/khuvsgulIcon.svg) —
// жинхэнэ логогоор солихдоо энэ файл болон public/khuvsgulIcon.*, favicon.ico-г л өөрчилнө.
// tone="light" — бараан дэвсгэр (footer) дээр цагаан бичигтэй.
const BrandLogo = ({ size = 42, tone = "dark" }) => (
  <span className="flex items-center gap-2.5">
    <Image src="/khuvsgulIcon.svg" alt={BRAND_NAME} width={size} height={size} unoptimized className="rounded-xl" />
    <span className="leading-none">
      <span className={`block font-display font-extrabold text-xl tracking-tight ${tone === "light" ? "text-white" : "text-brand-blue"}`}>
        {BRAND_NAME}
      </span>
      <span className="block mt-1 text-[11px] font-bold tracking-wide text-primary">{BRAND_TAGLINE}</span>
    </span>
  </span>
);

export default BrandLogo;
